import { render, staticRenderFns } from "./generator_histroy.vue?vue&type=template&id=58ea7762"
import script from "./generator_histroy.vue?vue&type=script&lang=js"
export * from "./generator_histroy.vue?vue&type=script&lang=js"
import style0 from "./generator_histroy.vue?vue&type=style&index=0&id=58ea7762&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports